import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useParams } from 'react-router-dom';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { showDate } from '../../../../_common/functions';
import { DATE_FORMAT } from '../../../../_common/constant';

interface genProps {
  partDetails: any;
}
const General: React.FC<genProps> = ({ partDetails }) => {
  const params: any = useParams();
  console.log('partDetails', partDetails);
  const facilityApi: any = useFacilitiesApi();
  const [rowData, setrowData] = useState<any>(null)
  const defaultLatitude = 40.712776; // Example default latitude (New York)
  const defaultLongitude = -74.005974; // Example default longitude (New York)
  const getAssetsList = (assetID: any) => {
    const payload: any = {
      FacilityID: partDetails?.facilityID
    };

    if (partDetails?.facilityID) {
      facilityApi.getFacilityList(payload, (resp: any) => {
        setrowData(resp.facilityList ? resp.facilityList[0] : []);

      }, (error: any) => {

      });

    }

  };


  useEffect(() => {
    if (params.id) {
      getAssetsList(params.id);
    }


  }, [params]);
  return (
    <div className='flex'>
      <div className='flex-grow border-r border-gray-200 pt-4'>
        <div className='grid grid-cols-2 gap-6'>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>General Information</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Part Code</div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsCode ? partDetails?.partsCode : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Part Name</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.sparePartsName ? partDetails?.sparePartsName : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Description</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsDescription ? partDetails?.partsDescription : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Category</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsCategoryName ? partDetails?.partsCategoryName : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Vendor Part Code</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.vendorPartCode ? partDetails?.vendorPartCode : '-'}
              </div>
            </div>
          </div>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Financial Summery</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Avg. Unit Cost  </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.costPerUnit ? partDetails?.costPerUnit : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Order Number </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastOrderNumber ? partDetails?.lastOrderNumber : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Order Date </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastOrdeDate ? showDate(partDetails?.lastOrdeDate, DATE_FORMAT) : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Received Date </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastReceivedDate ? showDate(partDetails?.lastReceivedDate, DATE_FORMAT) : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Min Stock Qty. </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.minStock ? partDetails?.minStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Max Stock Qty. </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.maxStock ? partDetails?.maxStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Total Stock on hand </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.currenctStock ? partDetails?.currenctStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className='w-[19.5rem] p-[1.125rem] overflow-y-auto flex-grow-0 flex-shrink-0'>
        <div className='max-w-[17.125rem] m-auto'>
          <img className='border border-gray-200 rounded-md' src={partDetails?.imageFullPath} alt="" />
          <h4 className='font-semibold text-[0.938rem] pt-5 pb-2'>Location</h4>
          <p className='text-[0.938rem] text-[#323233]'>{partDetails?.facilityName ? partDetails?.facilityName : '-'} </p>
          <LoadScript googleMapsApiKey="AIzaSyA2RiDzDVyJ75an-E5f4pAcsPo-HxoR9fM"> {/* Replace with your API key */}

            <GoogleMap
              mapContainerStyle={{
                width: '100%',
                height: '200px',
              }}
              center={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }}
              zoom={15} // Adjust zoom level as needed
            >

              <Marker position={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }} />
            </GoogleMap>

          </LoadScript>
          {/* <img className='mt-2' src={mapImg} alt="" /> */}
          {/* <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>
              {partDetails?.facilityName ? partDetails?.facilityName : '-'}

            </div> </div>
            <div className='w-3/4 text-[#323233]'>Paultry</div>
          </div> */}
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>  Status</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {partDetails?.partsStatusName ? partDetails?.partsStatusName : '-'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;